<!--
Feedback confirmation screen
@author cm359n
-->
<template>
  <div id="contain" class="container">
  <Nav name="Feedback" :back="false" />
  <div class="contain">
    <main class="p-2" id="feedbackmain">
      <p id="feedbackSubmitHdr">Thanks!</p>
      <p id="feedbackSubmitMsg">
        Your feedback is really important to us.
      </p>
      <img src="@/assets/voteEnd.svg" id="feedbackEndImg"/>
    </main>
    </div>
    <Footer active="index"/>
  </div>
</template>

<script>
import Footer from '@/components/FooterMenu.vue'

export default {
  name: 'FeedbackConfirmation',
  components: {
    Footer
  },
  data () {
    return {
    }
  },

  mounted () {

  },
  methods: {

  }
}
</script>
<style>
#feedbackReturn {
  border: 1px solid #951272;
  background-color:#951272;
  color:#ffffff;
  font-weight:700;
  border-radius:50px;
  text-align:center;
}

main.p-2#feedbackmain {
    text-align: center;
}

#feedbackSubmitHdr {
  margin-top:45px;
  font-weight: bold;
  font-size: 25px;
  text-align:center;
  color: var(--uog-dark-blue);
}

#feedbackSubmitMsg {
  text-align:center;
  color: var(--uog-dark-blue);
}

</style>
